import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface HomeCardMetaChipProps {
  label: string
  leading?: ReactNode
  tone?: 'overlay' | 'dark'
  className?: string
}

export function HomeCardMetaChip({
  label,
  leading,
  tone = 'overlay',
  className,
}: HomeCardMetaChipProps) {
  return (
    <div
      className={cn(
        'inline-flex max-w-full items-center gap-1.5 rounded-[25px] border px-2.5 py-0.5 text-[10.6px] font-medium leading-[1.4] backdrop-blur-sm',
        tone === 'overlay'
          ? 'border-white/35 bg-white/70 text-[hsl(var(--primary-dark))]'
          : 'border-white/10 bg-primary text-primary-foreground',
        className,
      )}
    >
      {leading ? <span className="shrink-0">{leading}</span> : null}
      <span className="truncate">{label}</span>
    </div>
  )
}
